import React, {Component} from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field} from 'redux-form';
import {
  Card,
  Button,
  Input,
  Radio,
  Form,
  Grid,
  Loader,
  Select,
  Icon,
  Popup,
} from 'semantic-ui-react';
import LeadTimeChart from '../chart';
import OrderDetail from '../../../../order/components/detail';
import {Actions} from '../../../../common/actions';
import {PROVIDER} from '../../../../common/forms';
import {toFloat} from '../../../../common/util/fieldsNormalization';
import {getSystemParameterValue} from '../../../../common/util/parametersUtils';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {paths} from '../../../../common/dictionaries/urls';

const transportTypes = [
  {'text': 'Aéreo', 'value': 'aerial'},
  {'text': 'Marítimo', 'value': 'maritime'},
  {'text': 'INEN Aéreo', 'value': 'inenAerial'},
  {'text': 'INEN Marítimo', 'value': 'inenMaritime'},
];

class ProviderForm extends Component {
  constructor(props) {
    super(props);
    this.onActiveDotClick = this.onActiveDotClick.bind(this);
  }

  componentDidMount() {
    const {viewMode} = this.props;
    if ((viewMode && !hasAccessPermission(this.props.permissions, resources.Providers, scopes.See)) ||
    (!viewMode && !hasAccessPermission(this.props.permissions, resources.Providers, scopes.Edit))) {
      this.props.push(paths.AccessDenied);
      return;
    }
    
    const {selectedProvider} = this.props;
    this.props.loadOrigins();
    this.props.toggleOrderDetail(false);
    this.props.loadProviderOrders(selectedProvider.code);
    this.props.initializeProviderData(selectedProvider);
    this.props.fetchSystemParameter('MPSSLT');
  }

  onCancelClick() {
    this.props.goBack();
  }
  
  onTransporTypeChange(event, data) {
    this.props.toggleOrderDetail(false);
    this.props.changeProviderTransportType(data.value);
  }

  onActiveDotClick(value) {
    const {selectedTransportType} = this.props;
    const ordersList = this.props[`${selectedTransportType}Orders`].orders;
    const order = ordersList.find((element) => element.order === value);

    this.props.toggleOrderDetail(true);
    this.props.selectOrder(order);
    this.scrollToBottomPage();
  }

  scrollToBottomPage() {
    const pageContent = document.getElementsByClassName('App-content')[0];
    pageContent.scrollTop = pageContent.scrollTopMax;
  }

  onHideOrderDetailClick() {
    this.props.toggleOrderDetail(false);
  }

  render() {
    const {
      loading,
      handleSubmit,
      submitting,
      selectedProvider,
      systemParameters,
      originsList,
      selectedTransportType,
      viewMode,
    } = this.props;

    return (
      <Form className='provider-form' onSubmit={handleSubmit}>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <Icon name='arrow left' onClick={this.onCancelClick.bind(this)} />
              <h2>{selectedProvider.name}</h2>
              {!viewMode && (
                <div className='title-bar-actions'>
                  <Button
                    secondary
                    type='button'
                    onClick={this.onCancelClick.bind(this)}
                    disabled={submitting}
                  >
                    Cancelar
                  </Button>
                  <Button primary type='submit' disabled={submitting}>
                    Guardar
                  </Button>
                </div>
              )}
            </div>
            <div className='subtitle'>
              <div>
                {selectedProvider.code} | {selectedProvider.identification}
              </div>
              <div>
                {selectedProvider.address} | {selectedProvider.phone}
              </div>
            </div>
            <div className='fields'>
              <div className='origin'>
                <strong>Origen</strong>
                <Field
                  name='origin'
                  component={this.renderSelect}
                  options={this.getOrigins(originsList)}
                />
              </div>
              <div className='order-cycle'>
                <div className='values'>
                  <span>Order Cycle</span>
                  <Field
                    name='manualOrderCycle'
                    component={Input}
                    maxLength={5}
                    pattern='[0-1]{1,2}([.][0-9]{1,2})?'
                    normalize={toFloat}
                    disabled={viewMode}
                  />
                  <span>Order Cycle Calculado*</span>
                  <span className='calc-value'>
                    {selectedProvider.orderCycle}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Card>
        <Card raised fluid>
          {loading && <Loader active inline='centered' />}
          {!loading && (
            <div className='primary-content'>
              <div className='section-title'>
                <h3>Lead Time</h3>
                <Popup
                  trigger={
                    <Icon link name='info circle' color='blue' size='big' />
                  }
                  on='click'
                  position='bottom left'
                  inverted
                >
                  <div>
                    El promedio es calculado considerando los pedidos que poseen
                    un porcentaje de atención mayor o igual al{' '}
                    {getSystemParameterValue(systemParameters, 'MPSSLT')}
                    %. Los máximos y minímos corresponden a los pedidos con
                    mayor y menor Lead Time respectivamente.
                  </div>
                </Popup>
              </div>
              {this.renderLeadTime()}
              {this.renderChart(selectedTransportType)}
            </div>
          )}
        </Card>
        <div id='order-detail' />
        {this.renderOrderDetail()}
      </Form>
    );
  }

  renderLeadTime() {
    return (
      <div className='lead-time'>
        <Grid columns={10}>
          {this.renderValuesLabels()}
          {this.renderHeaders()}
          {this.renderAerialValues()}
          {this.renderMaritimeValues()}
          {this.renderInenAerialValues()}
          {this.renderInenMaritimeValues()}
          {this.renderNotes()}
        </Grid>
      </div>
    );
  }

  renderValuesLabels() {
    return (
      <Grid.Row>
        <Grid.Column width={2}></Grid.Column>
        <Grid.Column width={6} textAlign='center'>
          <h3>Valores Reales</h3>
        </Grid.Column>
        <Grid.Column width={8} textAlign='center'>
          <h3>Parámetros utilizados para el SOQ</h3>
        </Grid.Column>
      </Grid.Row>
    );
  }

  renderHeaders() {
    return (
      <Grid.Row>
        <Grid.Column></Grid.Column>
        <Grid.Column>
          <strong>Prom*</strong>
        </Grid.Column>
        <Grid.Column>
          <strong>Max*</strong>
        </Grid.Column>
        <Grid.Column>
          <strong>Min*</strong>
        </Grid.Column>
        <Grid.Column>
          <strong>
            SS/LT*
            <Popup
              trigger={
                <Icon link name='info circle' color='blue' size='large' />
              }
              on='click'
              position='bottom left'
              inverted
            >
              <div>
                Fórmula utilizada: SS/LT = ((Max LT x 95%) – LT Promedio) / 30
              </div>
            </Popup>
          </strong>
        </Grid.Column>
        <Grid.Column textAlign='center'>
          <strong>Días</strong>
        </Grid.Column>
        <Grid.Column textAlign='center'>
          <strong>Max</strong>
        </Grid.Column>
        <Grid.Column textAlign='center'>
          <strong>Min</strong>
        </Grid.Column>
        <Grid.Column textAlign='center'>
          <strong>SS / LT</strong>
        </Grid.Column>
      </Grid.Row>
    );
  }

  renderNotes() {
    return (
      <Grid.Row>
        <Grid.Column width={8}>
          <div className='note'>
            * Valores calculados de los últimos seis meses a la fecha actual
          </div>
        </Grid.Column>
      </Grid.Row>
    );
  }

  renderAerialValues() {
    const {aerialOrders, selectedProvider} = this.props;
    return (
      <Grid.Row>
        <Grid.Column verticalAlign='middle' textAlign='left'>
          <strong>Aéreo</strong>
        </Grid.Column>
        <Grid.Column verticalAlign='middle'>{aerialOrders.average}</Grid.Column>
        <Grid.Column verticalAlign='middle'>{aerialOrders.max}</Grid.Column>
        <Grid.Column verticalAlign='middle'>{aerialOrders.min}</Grid.Column>
        <Grid.Column verticalAlign='middle'>
          {selectedProvider.aerialSafetyStockLeadTime || 0}
        </Grid.Column>
        <Grid.Column textAlign='center'>
          {this.renderLeadTimeField('manualAerialLeadTime')}
        </Grid.Column>
        <Grid.Column textAlign='center'>
          {this.renderLeadTimeField('manualAerialMax')}
        </Grid.Column>
        <Grid.Column textAlign='center'>
          {this.renderLeadTimeField('manualAerialMin')}
        </Grid.Column>
      </Grid.Row>
    );
  }

  renderMaritimeValues() {
    const {maritimeOrders, selectedProvider} = this.props;
    return (
      <Grid.Row>
        <Grid.Column verticalAlign='middle' textAlign='left'>
          <strong>Marítimo</strong>
        </Grid.Column>
        <Grid.Column verticalAlign='middle'>
          {maritimeOrders.average}
        </Grid.Column>
        <Grid.Column verticalAlign='middle'>{maritimeOrders.max}</Grid.Column>
        <Grid.Column verticalAlign='middle'>{maritimeOrders.min}</Grid.Column>
        <Grid.Column verticalAlign='middle'>
          {selectedProvider.maritimeSafetyStockLeadTime || 0}
        </Grid.Column>
        <Grid.Column textAlign='center'>
          {this.renderLeadTimeField('manualMaritimeLeadTime')}
        </Grid.Column>
        <Grid.Column textAlign='center'>
          {this.renderLeadTimeField('manualMaritimeMax')}
        </Grid.Column>
        <Grid.Column textAlign='center'>
          {this.renderLeadTimeField('manualMaritimeMin')}
        </Grid.Column>
        <Grid.Column>
          {this.renderLeadTimeField('manualMaritimeSafetyStockLeadTime')}
        </Grid.Column>
        <Grid.Column verticalAlign='middle' textAlign='left'>
          <Field
            name='defaultLeadTimeValues'
            props={{'value': 'MARITIMO'}}
            component={this.renderRadioButton}
          />
        </Grid.Column>
      </Grid.Row>
    );
  }

  renderInenAerialValues() {
    const {inenAerialOrders, selectedProvider} = this.props;
    return (
      <Grid.Row>
        <Grid.Column verticalAlign='middle' textAlign='left'>
          <strong>INEN Aéreo</strong>
        </Grid.Column>
        <Grid.Column verticalAlign='middle'>
          {inenAerialOrders.average}
        </Grid.Column>
        <Grid.Column verticalAlign='middle'>{inenAerialOrders.max}</Grid.Column>
        <Grid.Column verticalAlign='middle'>{inenAerialOrders.min}</Grid.Column>
        <Grid.Column verticalAlign='middle'>
          {selectedProvider.inenAerialSafetyStockLeadTime || 0}
        </Grid.Column>
        <Grid.Column textAlign='center'>
          {this.renderLeadTimeField('manualInenAerialLeadTime')}
        </Grid.Column>
        <Grid.Column textAlign='center'>
          {this.renderLeadTimeField('manualInenAerialMax')}
        </Grid.Column>
        <Grid.Column textAlign='center'>
          {this.renderLeadTimeField('manualInenAerialMin')}
        </Grid.Column>
      </Grid.Row>
    );
  }

  renderInenMaritimeValues() {
    const {inenMaritimeOrders, selectedProvider} = this.props;
    return (
      <Grid.Row>
        <Grid.Column verticalAlign='middle' textAlign='left'>
          <strong>INEN Marítimo</strong>
        </Grid.Column>
        <Grid.Column verticalAlign='middle'>
          {inenMaritimeOrders.average}
        </Grid.Column>
        <Grid.Column verticalAlign='middle'>
          {inenMaritimeOrders.max}
        </Grid.Column>
        <Grid.Column verticalAlign='middle'>
          {inenMaritimeOrders.min}
        </Grid.Column>
        <Grid.Column verticalAlign='middle'>
          {selectedProvider.inenMaritimeSafetyStockLeadTime || 0}
        </Grid.Column>
        <Grid.Column textAlign='center'>
          {this.renderLeadTimeField('manualInenMaritimeLeadTime')}
        </Grid.Column>
        <Grid.Column textAlign='center'>
          {this.renderLeadTimeField('manualInenMaritimeMax')}
        </Grid.Column>
        <Grid.Column textAlign='center'>
          {this.renderLeadTimeField('manualInenMaritimeMin')}
        </Grid.Column>
        <Grid.Column>
          {this.renderLeadTimeField('manualInenMaritimeSafetyStockLeadTime')}
        </Grid.Column>
        <Grid.Column verticalAlign='middle' textAlign='left'>
          <Field
            name='defaultLeadTimeValues'
            props={{'value': 'INEN MARITIMO'}}
            component={this.renderRadioButton}
          />
        </Grid.Column>
      </Grid.Row>
    );
  }

  renderLeadTimeField = (fieldName) => {
    const {viewMode} = this.props;
    return (
      <Field
        name={fieldName}
        component={Input}
        maxLength={6}
        pattern='[0-9]{1,3}([.][0-9]{1,2})?'
        normalize={toFloat}
        disabled={viewMode}
      />
    );
  }

  renderRadioButton = (field) => {
    const {viewMode} = this.props;
    return (
      <Radio
        value={field.value}
        label={field.value === field.input.value ? 'Default' : ''}
        checked={field.value === field.input.value}
        onChange={(e, {value}) => field.input.onChange(value)}
        disabled={viewMode}
      />
    );
  };

  renderSelect = (field) => {
    const {viewMode} = this.props;
    return (
      <Select
        options={field.options}
        value={field.input.value}
        onChange={(e, {value}) => field.input.onChange(value)}
        disabled={viewMode}
      />
    );
  };

  renderChart(selectedTransportType) {
    const orders = this.props[`${selectedTransportType}Orders`];

    return (
      <>
        <div className='chart-options'>
          <strong>Tipo de transporte</strong>
          <Select
            options={transportTypes}
            value={selectedTransportType}
            onChange={this.onTransporTypeChange.bind(this)}
          />
          <Popup
            trigger={<Icon link name='info circle' color='blue' size='big' />}
            on='click'
            position='bottom left'
            inverted
          >
            <div>
              Los valores graficados corresponden a todos los pedidos del tipo
              de transporte seleccionado, los límites de la gráfica están
              calculados en base a la desviación estándar.
            </div>
          </Popup>
        </div>
        {orders && (<LeadTimeChart
          data={orders.orders}
          average={orders.average}
          onActiveDotClick={this.onActiveDotClick}
        />)}
      </>
    );
  }

  renderOrderDetail() {
    const {showOrderDetail, selectedOrder} = this.props;

    if (selectedOrder) {
      return (
        <Card raised fluid className={showOrderDetail ? '' : 'card-hidden'}>
          <div className='order-detail'>
            <div className='title'>
              <h3>
                Pedido {selectedOrder.order} - {selectedOrder.leadtime} Días
              </h3>
              <Icon
                link
                name='close'
                onClick={this.onHideOrderDetailClick.bind(this)}
              />
            </div>
            <OrderDetail selectedOrder={selectedOrder.order} />
          </div>
        </Card>
      );
    }

    return null;
  }

  getOrigins(list) {
    return list.map((element) => {
      return {'text': element.origin, 'value': element.code};
    });
  }
}

export {ProviderForm};

const form = reduxForm({
  'form': PROVIDER.name,
})(ProviderForm);

const mapStateToProps = (state, ownProps) => {
  const {aerial, inenAerial, inenMaritime, maritime} =
    state.form.provider.ordersList;
  return {
    'loading': state.form.provider.loadingOrders,
    'loadingOrigins': state.origin.loading,
    'originsList': state.origin.list,
    'selectedTransportType': state.form.provider.selectedTransportType,
    'selectedOrder': state.form.provider.selectedOrder,
    'showOrderDetail': state.form.provider.showOrderDetail,
    'aerialOrders': aerial || {},
    'inenAerialOrders': inenAerial || {},
    'maritimeOrders': maritime || {},
    'inenMaritimeOrders': inenMaritime || {},
    'systemParameters': state.parameters.list,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  initializeProviderData,
  loadProviderOrders,
  loadOrigins,
  selectOrder,
  changeProviderTransportType,
  toggleOrderDetail,
  fetchSystemParameter,
} = Actions;

export default connect(mapStateToProps, {
  initializeProviderData,
  loadProviderOrders,
  loadOrigins,
  selectOrder,
  changeProviderTransportType,
  toggleOrderDetail,
  fetchSystemParameter,
})(form);
